import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSyncWaiting = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	height: 20,
	viewBox: "0 0 20 20",
	width: 20,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("circle", {
		cx: 10,
		cy: 10,
		r: 8,
		stroke: "#cdd4da",
		strokeWidth: 3
	})
});
export { SvgSyncWaiting as ReactComponent };
